import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DELETE_MESSAGE,
} from "../../common/Constant";
import { toastSuccess } from "../../common/Toast";
import Select from "react-select";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import config from "../../config/config";

const DeliveryStatusConfirmation = ({
  open,
  onClose,
  setShowDeliverySelect,
  showDeliverySelect,
  deliveryStatusList,
}) => {
  const handleSubmit = () => {
    //put your validation logic here
    const token = localStorage.getItem("Token");

    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/updatesaledeliverystatus`,
        {
          saleId: showDeliverySelect?.id,
          DeliveryStatusID: showDeliverySelect?.DeliveryStatusID,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then(() => {
        toastSuccess(DELETE_MESSAGE);
        // window.location.reload();
      });
    // closeMenuofrow()
    onClose();
  };

  return (
    <Dialog open={open}  maxWidth={"sm"} fullWidth={true} scroll={"paper"} >
      <DialogTitle textAlign="center">Delivery Status</DialogTitle>

      <DialogContent style={{height: '300px'}}>
        <div >
        <Select
          options={deliveryStatusList}
          onChange={(e) => {
            setShowDeliverySelect((prev) => {
              return {
                ...prev,
                DeliveryStatusID: e?.value,
              };
            });
          }}
          value={deliveryStatusList?.find(
            (el) => el.ID === showDeliverySelect?.DeliveryStatusID
          )}
          // backspaceRemovesValue={false}
          // controlShouldRenderValue={true}
          // isClearable={true}
          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
          style={{height: '100px'}}
          className="custom-search-select mt-1"
          />
          </div>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button class="btn btn-sm btn-outline-dark" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button
          class="btn btn-sm btn-primary"
          onClick={handleSubmit}
          variant="contained"
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeliveryStatusConfirmation;
